import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "dropdownMenu",
    class: _normalizeClass(["dropdown-menu show", `dropdown-menu-${_ctx.side} dropdown-menu-${_ctx.size}`])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}